(() => {
  const storageKey = "shibui:wishlist:v1";
  const productSelector = "[data-wishlist-toggle]";
  let items = readItems();

  function readItems() {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(storageKey) || "[]");
      if (!Array.isArray(parsed)) return [];

      return parsed.filter((item) => item && typeof item.id === "string" && item.id.length > 0);
    } catch {
      return [];
    }
  }

  function writeItems() {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(items));
    } catch {
      // The current page still works when storage is unavailable; persistence is simply skipped.
    }
  }

  function productFromButton(button) {
    return {
      id: String(button.dataset.wishlistProductId || ""),
      handle: String(button.dataset.wishlistHandle || ""),
      title: String(button.dataset.wishlistTitle || "Product"),
      url: String(button.dataset.wishlistUrl || "#"),
      image: String(button.dataset.wishlistImage || ""),
      price: String(button.dataset.wishlistPrice || ""),
    };
  }

  function isSaved(productId) {
    return items.some((item) => item.id === String(productId));
  }

  function updateButtons(root = document) {
    root.querySelectorAll(productSelector).forEach((button) => {
      const saved = isSaved(button.dataset.wishlistProductId);
      const title = button.dataset.wishlistTitle || "this product";
      const label = saved ? `Remove ${title} from wishlist` : `Add ${title} to wishlist`;

      button.setAttribute("aria-pressed", String(saved));
      button.setAttribute("aria-label", label);
      button.setAttribute("title", label);
    });
  }

  function updateHeaderLabel() {
    const count = items.length;
    const label = count === 0
      ? "Open wishlist"
      : `Open wishlist, ${count} ${count === 1 ? "product" : "products"}`;

    document.querySelectorAll("[data-wishlist-header-label]").forEach((element) => {
      element.textContent = label;
    });

    document.querySelectorAll("[data-wishlist-header-count]").forEach((element) => {
      element.textContent = String(count);
      element.classList.toggle("opacity-0", count === 0);
    });
  }

  function makeItem(product) {
    const item = document.createElement("li");
    item.className = "wishlist-drawer__item";
    item.dataset.wishlistItemId = product.id;

    const imageLink = document.createElement("a");
    imageLink.className = "wishlist-drawer__image-link";
    imageLink.href = product.url;
    imageLink.setAttribute("aria-label", `View ${product.title}`);

    if (product.image) {
      const image = document.createElement("img");
      image.className = "wishlist-drawer__image";
      image.src = product.image;
      image.alt = product.title;
      image.loading = "lazy";
      image.width = 176;
      image.height = 220;
      imageLink.appendChild(image);
    }

    const content = document.createElement("div");
    content.className = "wishlist-drawer__item-content";

    const removeButton = document.createElement("button");
    removeButton.type = "button";
    removeButton.className = "wishlist-drawer__remove wishlist-toggle";
    removeButton.dataset.wishlistToggle = "";
    removeButton.dataset.wishlistProductId = product.id;
    removeButton.dataset.wishlistHandle = product.handle;
    removeButton.dataset.wishlistTitle = product.title;
    removeButton.dataset.wishlistUrl = product.url;
    removeButton.dataset.wishlistImage = product.image;
    removeButton.dataset.wishlistPrice = product.price;
    removeButton.setAttribute("aria-pressed", "true");
    removeButton.setAttribute("aria-label", `Remove ${product.title} from wishlist`);
    removeButton.setAttribute("title", `Remove ${product.title} from wishlist`);
    removeButton.innerHTML = '<svg class="wishlist-heart" viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false"><path class="wishlist-heart__shape" d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z" /></svg>';

    const title = document.createElement("a");
    title.className = "wishlist-drawer__title bold";
    title.href = product.url;
    title.textContent = product.title;
    content.appendChild(title);

    if (product.price) {
      const price = document.createElement("p");
      price.className = "wishlist-drawer__price";
      price.textContent = product.price;
      content.appendChild(price);
    }

    const actions = document.createElement("div");
    actions.className = "wishlist-drawer__actions";

    const quickBuyId = `wishlist-quick-buy-${product.id.replace(/[^a-zA-Z0-9_-]/g, "")}`;

    const addButton = document.createElement("button");
    addButton.type = "button";
    addButton.className = "button button--xl w-full wishlist-drawer__add";
    addButton.setAttribute("aria-controls", quickBuyId);
    addButton.setAttribute("aria-expanded", "false");
    addButton.textContent = "Add to cart";

    const quickBuyDrawer = document.createElement("quick-buy-drawer");
    quickBuyDrawer.id = quickBuyId;
    quickBuyDrawer.className = "quick-buy-drawer drawer";
    quickBuyDrawer.setAttribute("header-bordered", "");
    quickBuyDrawer.setAttribute("open-from", "bottom");
    quickBuyDrawer.setAttribute("handle", product.handle);
    quickBuyDrawer.setAttribute("role", "region");
    quickBuyDrawer.setAttribute("aria-live", "polite");

    actions.append(addButton);
    content.appendChild(actions);
    item.append(imageLink, content, removeButton, quickBuyDrawer);

    return item;
  }

  function renderDrawer() {
    const drawer = document.getElementById("wishlist-drawer");
    if (!drawer) return;

    const list = drawer.querySelector("[data-wishlist-items]");
    const empty = drawer.querySelector("[data-wishlist-empty]");
    const count = drawer.querySelector("[data-wishlist-count]");
    if (!list || !empty || !count) return;

    list.replaceChildren(...items.map(makeItem));
    list.hidden = items.length === 0;
    empty.hidden = items.length > 0;
    count.textContent = String(items.length);
    count.classList.toggle("opacity-0", items.length === 0);
  }

  function announce(message) {
    const status = document.querySelector("[data-wishlist-status]");
    if (!status) return;
    status.textContent = "";
    window.setTimeout(() => {
      status.textContent = message;
    }, 30);
  }

  function syncUi() {
    updateButtons();
    updateHeaderLabel();
    renderDrawer();
    wireQuickBuyDrawers();
  }

  function handoffFromQuickBuy(event) {
    const quickBuyDrawer = event.currentTarget;

    window.setTimeout(() => {
      if (typeof quickBuyDrawer.hide === "function") {
        quickBuyDrawer.hide();
      }
      openCartPage();
    }, 0);
  }

  function wireQuickBuyDrawers(root = document) {
    root.querySelectorAll("quick-buy-drawer[data-product-card-quick-buy]").forEach((drawer) => {
      if (drawer.dataset.cartHandoffBound === "true") return;
      drawer.dataset.cartHandoffBound = "true";
      drawer.addEventListener("variant:add", handoffFromQuickBuy);
    });
  }

  function toggleProduct(button) {
    const product = productFromButton(button);
    if (!product.id) return;

    if (isSaved(product.id)) {
      items = items.filter((item) => item.id !== product.id);
      announce(`${product.title} removed from wishlist.`);
    } else {
      items = [product, ...items.filter((item) => item.id !== product.id)];
      announce(`${product.title} added to wishlist.`);
    }

    writeItems();
    syncUi();
  }

  document.addEventListener("click", (event) => {
    const toggle = event.target.closest(productSelector);
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      toggleProduct(toggle);
    }
  });

  document.addEventListener("click", (event) => {
    const control = event.target.closest("[data-cart-quantity-action]");
    if (control) {
      event.preventDefault();
      const quantityControl = control.closest("line-item-quantity");
      const input = quantityControl?.querySelector("input[data-line-key]");
      if (!input) return;

      const action = control.dataset.cartQuantityAction;
      const currentQuantity = parseInt(input.value, 10) || 1;
      input.value = action === "remove"
        ? String(Math.max(currentQuantity - 1, 0))
        : String(currentQuantity + 1);
      input.dispatchEvent(new Event("change", { bubbles: true }));
      return;
    }

    const moveButton = event.target.closest("[data-move-to-wishlist]");
    if (!moveButton) return;

    event.preventDefault();
    const product = productFromButton(moveButton);
    if (!product.id || !product.handle) return;

    if (!isSaved(product.id)) {
      items = [product, ...items.filter((item) => item.id !== product.id)];
      writeItems();
      syncUi();
      announce(`${product.title} moved to wishlist.`);
    }

    const lineItem = moveButton.closest("line-item");
    const input = lineItem?.querySelector("input[data-line-key]");
    if (input) {
      input.value = "0";
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });

  function openCartPage() {
    const root = window.Shopify?.routes?.root || "/";
    window.location.assign(`${root}cart`);
  }

  // Quick-buy drawers normally open the cart drawer after a variant is added.
  // Send shoppers to the full cart page instead, including wishlist quick buys.
  document.addEventListener("variant:add", (event) => {
    const quickBuyDrawer = event.target?.closest?.("quick-buy-drawer");
    if (!quickBuyDrawer) return;

    window.setTimeout(() => {
      if (quickBuyDrawer && typeof quickBuyDrawer.hide === "function") {
        quickBuyDrawer.hide();
      }
      openCartPage();
    }, 0);
  });

  document.addEventListener("shopify:section:load", (event) => {
    updateButtons(event.target);
    updateHeaderLabel();
  });

  window.addEventListener("storage", (event) => {
    if (event.key !== storageKey) return;
    items = readItems();
    syncUi();
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncUi, { once: true });
  } else {
    syncUi();
  }
})();
